import { Menu } from '../../features/rightmenu/menu.tsx'
import { useIsMobile } from '../../shared/lib/hooks.ts'
import { cn } from '../../shared/lib/utils.ts'
import React from 'react'

/**
 * Оболочка урока: сайдбар + контент — одна группа по центру экрана.
 * Боковые колонки 1fr|auto|1fr дают равные поля; gap меню↔полотно маленький.
 */
export function ChatPageShell(props: {
  children: React.ReactNode
  className?: string
}) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <div className={cn('relative h-dvh w-full', props.className)}>
        {props.children}
      </div>
    )
  }

  return (
    <div
      className={cn(
        'grid h-dvh w-full grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] px-16 2xl:px-24',
        props.className,
      )}
    >
      <div aria-hidden className="min-w-0" />
      <div className="flex h-full max-w-[calc(100vw-2rem)] gap-16 2xl:max-w-[calc(100vw-3rem)] 2xl:gap-24">
        <Menu />
        <div className="relative flex h-full w-[min(1224px,calc(100vw-280px))] min-w-0 flex-col 2xl:w-[min(1600px,calc(100vw-380px))]">
          {props.children}
        </div>
      </div>
      <div aria-hidden className="min-w-0" />
    </div>
  )
}
